import React from 'react'
import "./Navbar.css"
import { NavLink } from 'react-router-dom';

function Navbar() {
  return (
    <div>
     
    <nav class="navbar fixed-top navbar-expand-lg bg-light">
  <div class="container-fluid">
  <div>
  <NavLink class="nav-link active nav-link1 text-hover" aria-current="page" href="#" to="/" style={{ textDecoration: 'none',color:'black' }}>
     <img
              loading="lazy"
              src="https://i.postimg.cc/qM1h2tHF/nss.png"
              class="img me-2"
              alt="sampleimage"
          />
    <a class="navbar-brand fw-bold" href="#">       
       PICT NSS</a>
  </NavLink>
  </div>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">

        <li class="nav-item me-5">
          <NavLink class="nav-link active nav-link1 text-hover" aria-current="page" href="#" to="/" style={{ textDecoration: 'none',color:'black' }}>Home</NavLink>
        </li>

        <li class="nav-item me-5">
          <NavLink class="nav-link text-hover" to='/team' style={{ textDecoration: 'none',color:'black' }}>Teams</NavLink>
        </li>

        <li class="nav-item me-5">
          <NavLink class="nav-link text-hover" to="/activity" style={{ textDecoration: 'none',color:'black' }}>Activities</NavLink>
        </li>

        <li class="nav-item me-5">
          <NavLink class="nav-link text-hover" to="/gallery" style={{ textDecoration: 'none',color:'black' }}>Gallery</NavLink>
        </li>

        <li class="nav-item me-5">
          <NavLink class="nav-link text-hover" to="/camp" style={{ textDecoration: 'none',color:'black'}}>Camp</NavLink>
        </li>

      </ul>
    </div>
  </div>
</nav>
    </div>
  )
}

export default Navbar;
